<div class="row">
    <div class="col-sm-3">
        <div class="card">
            <div class="card-body">
                <h4>Time Report</h4>
                <hr>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <button (click)="postLogTime()" class="btn btn-outline-secondary" type="button">Clock
                            In/Out</button>
                    </div>
                    <select class="custom-select" [(ngModel)]="eeSelected">
                        <option value="0">Everyone</option>
                        <option *ngFor="let ee of eeList" value="{{ee.EEID}}">{{ee.FULLNAME}}</option>
                    </select>
                </div>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Start Date</span>
                    </div>
                    <input [(ngModel)]="startDate" type="date" aria-label="Start Date" class="form-control">
                </div>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">End Date</span>
                    </div>
                    <input [(ngModel)]="endDate" type="date" aria-label="End Date" class="form-control">
                </div>
                <button class="btn btn-secondary w-100 mb-3" value="Run Time Report" (click)="getDetailReport()">Run
                    Time
                    Report</button>
                <p class="infoBox">{{infoBox}}</p>
            </div>
        </div>
        <div *ngIf="showSummary" class="card">
            <div class="card-body">
                <h4>{{startDate | date:'mediumDate'}} to {{endDate | date:'mediumDate'}}</h4>
                <hr>
                <p *ngFor="let ee of summaryReport">{{ee.FULLNAME}}: {{ee.TOTAL}} Hours</p>
            </div>
        </div>
    </div>
    <div class="col-sm-9">
        <div class="list-group">
            <button *ngFor="let det of timeReport" type="button" class="list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-between">
                    <p class="mb-1"><strong>{{det.FULLNAME}}</strong></p>
                    <p class="mb-1">Time In: {{det.TIMEIN}}</p>

                </div>
                <div class="d-flex w-100 justify-content-between">
                    <p class="mb-1">Normal Time</p>
                    <p class="mb-1">{{det.DATE | date:'mediumDate'}}</p>
                    <p class="mb-1">Total Hours: {{det.TIME }}</p>
                    <p class="mb-1">Time Out: {{det.TIMEOUT}}</p>
                </div>
            </button>
        </div>
    </div>
</div>